import React from "react";

/**
 * DisneyAvailabilitySection — mandatory confirmation checkbox shown when
 * EITHER end of the trip is a Disney resort. Disney requires we meet the
 * customer in person, so we need explicit acknowledgement that they'll be
 * physically present at the resort lobby during their chosen 1-hour
 * window(s). Legally protects us against no-shows.
 */
export const DisneyAvailabilitySection = ({
  isDisney,
  isPickupDisney,
  samePickup = false,
  resort,
  pickupResort,
  disneyAvailability,
  onChange,
}) => (
  <div className="mt-6 pt-6 border-t border-[#FFD166]/10" data-testid="disney-availability-section">
    <label className="eyebrow text-[#FFD166] flex items-center gap-2 mb-3">
      4 · Resort meet-up confirmation
      {disneyAvailability && <span className="text-emerald-400 text-[11px]" data-testid="disney-availability-check">✓</span>}
    </label>
    <label
      className={`flex items-start gap-3 p-4 rounded-xl border-2 cursor-pointer transition-colors ${disneyAvailability ? "border-emerald-500/50 bg-emerald-500/5" : "border-[#F4A93A] bg-[#F4A93A]/5"}`}
      data-testid="disney-availability-wrap"
    >
      <input
        type="checkbox"
        required
        checked={disneyAvailability}
        onChange={(e) => onChange(e.target.checked)}
        className="mt-1 w-4 h-4 accent-[#FFD166] shrink-0"
        data-testid="disney-availability-checkbox"
      />
      <div className="text-sm leading-relaxed">
        <div className="font-medium text-[#F6F1E4]">
          {isDisney && isPickupDisney ? (
            <>I confirm I&rsquo;ll be at <b className="text-[#FFD166]">{resort}</b>&rsquo;s lobby for delivery <em>and</em> at <b className="text-[#FFD166]">{pickupResort}</b>&rsquo;s lobby for pickup during my chosen 1-hour windows.</>
          ) : isDisney && samePickup ? (
            <>I confirm I&rsquo;ll be physically at <b className="text-[#FFD166]">{resort}</b>&rsquo;s lobby for <em>both</em> my delivery window <em>and</em> my pickup window.</>
          ) : isDisney ? (
            <>I confirm I&rsquo;ll be physically at <b className="text-[#FFD166]">{resort}</b>&rsquo;s lobby during my delivery window.</>
          ) : (
            <>I confirm I&rsquo;ll be physically at <b className="text-[#FFD166]">{pickupResort}</b>&rsquo;s lobby during my pickup window.</>
          )}
        </div>
        <p className="text-[11px] text-[#B9C8D5] mt-2">
          This resort requires we meet you in person for <b className="text-[#F4A93A]">both delivery and pickup</b> — there is no bell-services drop-off. During each selected window I&rsquo;ll be <b className="text-[#F4A93A]">fully available at the resort</b> — not still en route from the airport, not at the parks, not on Disney transport, and not tied up with other plans. If I&rsquo;m unreachable when our driver arrives, my hand-off may be delayed or my rental cancelled without refund.
        </p>
      </div>
    </label>
  </div>
);

export default DisneyAvailabilitySection;
